angular.module('SpidApp')

.controller('ProductChoiceController',
[		 '$uibModalInstance', '$scope','StockService','$rootScope',
function ($uibModalInstance,   $scope,StockService,$rootScope) {
	$scope.productChoice = {
		quantity : 1
	}

	$scope.waiting = true;

	StockService.findByAgencyIdAndStockId($rootScope.configs.agencyId, $scope.selectedProduct.id).then(function (stock) {
		if(typeof stock.quantity == 'undefined'){
			stock.quantity = 0;
		}
		$scope.stock = stock;
		$scope.waiting = false;
	});

	$scope.ok = function () {
		if ($scope.productChoiceForm.$valid) {
			$uibModalInstance.close($scope.productChoice)
		}
	}

	$scope.cancel = function () {
		$uibModalInstance.dismiss('cancel')
	}
	
	$scope.incrementQuantity = function () {
		if (!$scope.productChoice) {
			return
		}
		if (!$scope.productChoice.quantity) {
			$scope.productChoice.quantity = 0;
		}
		$scope.productChoice.quantity = $scope.productChoice.quantity + 1;
	}

	$scope.decrementQuantity = function () {
		if (!$scope.productChoice) {
			return
		}
		if ($scope.productChoice.quantity && $scope.productChoice.quantity !== 0) {
			$scope.productChoice.quantity = $scope.productChoice.quantity - 1;
		}
	}
}])